import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, resolveFileUrl } from "../api";
import { PageHeader, EmptyState } from "../components/ui-bits";

export default function BooksPage() {
  const [items, setItems] = useState([]);
  const [products, setProducts] = useState([]);
  useEffect(() => {
    api.get("/content/books").then((r) => setItems(r.data));
    api.get("/products?category=book").then((r) => setProducts(r.data));
  }, []);
  return (
    <div className="pb-32">
      <PageHeader kicker="THE LIBRARY" title="BOOKS" sub="Read in-browser. Buy the printed edition. Documentation of the culture, in long form." />
      <div className="divider-tape" />
      <div className="max-w-[1600px] mx-auto px-4 sm:px-6 py-10">
        <div className="font-mono-label text-[10px] text-[var(--accent)] mb-3">READ IN-BROWSER</div>
        {items.length === 0 ? <EmptyState>No books yet.</EmptyState> : (
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-5 mb-16" data-testid="books-grid">
            {items.map((b) => (
              <Link key={b.id} to={`/books/${b.id}`} className="card-brut block group" data-testid={`book-card-${b.id}`}>
                <div className="aspect-[2/3] overflow-hidden">
                  <img src={resolveFileUrl(b.cover_image)} alt={b.title} className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105" />
                </div>
                <div className="p-4 border-t border-neutral-800">
                  <div className="font-headline text-sm uppercase truncate">{b.title}</div>
                  <div className="font-mono-label text-[10px] text-neutral-400 mt-1">{b.artist}</div>
                </div>
              </Link>
            ))}
          </div>
        )}

        {products.length > 0 && (
          <>
            <div className="font-mono-label text-[10px] text-[var(--accent)] mb-3">BUY PRINTED COPIES</div>
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-5">
              {products.map((p) => (
                <Link key={p.id} to={`/merch/${p.id}`} className="card-brut block group" data-testid={`book-product-${p.id}`}>
                  <div className="aspect-[2/3] overflow-hidden">
                    <img src={resolveFileUrl(p.image)} alt={p.title} className="w-full h-full object-cover" />
                  </div>
                  <div className="p-4 border-t border-neutral-800 flex justify-between items-center">
                    <div className="font-headline text-sm uppercase truncate max-w-[120px]">{p.title}</div>
                    <div className="font-display text-xl">${p.price.toFixed(0)}</div>
                  </div>
                </Link>
              ))}
            </div>
          </>
        )}
      </div>
    </div>
  );
}
